<template lang="html">
  <div class="profile-group-box white-box row">
    <EditGroup v-if="groupEdit" :groupName="groupData.name" @close="groupEdit = false;" @rename="renamePopup = true; groupEdit = false;" @editContent="contentEditor = true; groupEdit = false;" @delete="deleteGroupPrompt();"></EditGroup>
    <NewGroup v-if="renamePopup" @close="renamePopup = false" :renameValue="groupData.name" @groupRenamed="changeGroupName"></NewGroup>
    <EditGroupContent v-if="contentEditor" :groupData="groupData" @close="contentEditor = false;" @groupContentChanged="updateGroupContent"></EditGroupContent>

    <div class="user-group-headline col-12" @click="renamePopup = true;">
      {{ groupData.name }}
    </div>

    <ul class="col-12 no-pad-both">
      <template v-for="(r, index) in (renderLimit || lengthOfChildren)">
        <ProfileFavoriteChild :childData="groupLikeData[index]" :removeLikeFunction="true" v-if="groupLikeData[index]"></ProfileFavoriteChild>
      </template>
    </ul>

    <div class="group-edit-bar col-md-4 col-6 text-center no-pad-both" @click="groupEdit = true;" tabindex="0">
      <span>Rediger samling<span class="material-icons group-functions-icon grey-text" aria-hidden="true">edit</span></span>
    </div>

    <div class="d-none d-sm-block col-md-4">
      <div class="no-pad-both show-all" @click="showMore();" v-show="lengthOfChildren > 6" tabindex="0">
        <span aria-label="Vis alle" v-if="renderLimit">Vis alle <span aria-hidden="true" class="material-icons">keyboard_arrow_down</span></span>
        <span aria-label="Vis færre" v-else>Vis færre <span aria-hidden="true" class="material-icons">keyboard_arrow_up</span></span>
      </div>
    </div>

    <div class="group-show-on-map-bar col-md-4 col-6 text-center no-pad-both">
      <router-link :to="{path: '/usergroup/'+groupData.id}" class="no-hover">
        Vis på kort<span class="material-icons group-functions-icon grey-text" aria-hidden="true">map</span>
      </router-link>
    </div>

    <div class="d-block d-sm-none col-12">
      <div class="no-pad-both show-all" @click="showMore();" v-show="lengthOfChildren > 4" tabindex="0">
        <span aria-label="Vis alle" v-if="renderLimit">Vis alle <span aria-hidden="true" class="material-icons">keyboard_arrow_down</span></span>
        <span aria-label="Vis færre" v-else>Vis færre <span aria-hidden="true" class="material-icons">keyboard_arrow_up</span></span>
      </div>
    </div>

  </div>
</template>

<script>
import ProfileFavoriteChild from '@/components/profile/ProfileFavoriteChild.vue'
import Profile from '@/assets/profile/Profile.js'
import EditGroup from '@/components/profile/EditGroup.vue'
import NewGroup from '@/components/profile/NewGroup.vue'
import EditGroupContent from '@/components/profile/EditGroupContent.vue'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      groupLikeData: [],
      groupEdit: false,
      renamePopup: false,
      contentEditor: false,
      renderLimit: 6,
      lengthOfChildren: false,
    }
  },
  props: {
    groupData: {
      required: true,
    }
  },
  components: {
    ProfileFavoriteChild, EditGroup, NewGroup, EditGroupContent
  },
  watch: {
    groupData() {
      this.getData();
    }
  },
  created() {
    if(this.$DeviceCheck.isMobile) {
      this.renderLimit = 4;
    }
    this.getData();
  },
  methods: {
    getData() {
      Profile.getLikeData(this.groupData.likes, true).then((data) => {
        this.groupLikeData = data;
        if(this.groupLikeData.length == undefined) {
          this.lengthOfChildren = Object.keys(this.groupLikeData).length;
        }
        else {
          this.lengthOfChildren = this.groupLikeData.length;
        }
      });
    },

    changeGroupName(name) {
      this.renamePopup = false;
      if(name == '') {
        name = 'Intet navn';
      }
      Profile.renameGroup(this.groupData.id, name);
    },

    updateGroupContent() {
      this.contentEditor = false;
      this.getData();
    },

  	deleteGroupPrompt() {
      this.groupEdit = false;
      var obj = {message: 'Er du sikker på at du vil slette samlingen?', cancelBtnText: 'Annuler', btnText: 'Ja', callbackType: 'function', callback: this.deleteGroup};
      EventBus.$emit('openMessageBox', obj);
  	},

    deleteGroup() {
      Profile.deleteGroup(this.groupData.id);
    },

    showMore: function(ev) {
      if(!this.renderLimit) {
        this.renderLimit = (this.$DeviceCheck.isMobile) ? 4 : 6;
      }
      else {
        this.renderLimit = false;
      }
  	}
  }
}
</script>

<style lang="css" scoped>
  .profile-group-box {
    margin-top: 10px;
  }

  .user-group-headline {
    height: 45px;
    margin: 5px 0px;
    line-height: 45px;
    vertical-align: middle;
    text-align: center;
    font-size: 20px;
  	text-transform: uppercase;
  	color: rgb(000,112,141);
  }

  .group-edit-bar, .group-show-on-map-bar {
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    text-transform: uppercase;
    color: rgb(000,112,141);
    cursor: pointer;
  }

  .group-edit-bar span, .group-show-on-map-bar a {
    padding-right: 20px;
  }

  .group-functions-icon {
    position: absolute;
    font-size: 20px !important;
    top: 5px;
  }

  .show-all {
    height: 25px;
    line-height: 25px;
    font-size: 15px;
    text-align: center;
    vertical-align: middle;
    margin-bottom: 10px;
    color: rgb(000,112,141);
    cursor: pointer;
  }

  .show-all .material-icons {
    vertical-align: middle;
  }
</style>
